import { registerLocaleData } from '@angular/common';
import localeCzech from '@angular/common/locales/cs';
import localeGerman from '@angular/common/locales/de';
import { Injectable } from '@angular/core';
import { SourceFileEntity } from 'wflow-cdk';

@Injectable()
export class SessionService {
  private _locale: string;
  private _maxFileSizeToUpload = SourceFileEntity.maxFileSize;

  set locale(value: string) {
    this._locale = value;
  }
  get locale(): string {
    return this._locale || 'cs-CZ';
  }

  get maxFileSizeToUpload(): number {
    return this._maxFileSizeToUpload;
  }

  getLocale(): string {
    return this.locale;
  }

  registerCulture(culture: string) {
    if (!culture) {
      return;
    }
    this.locale = culture;

    // Register locale data since only the en-US locale data comes with Angular
    switch (culture) {
      case 'cs-CZ': {
        registerLocaleData(localeCzech);
        break;
      }
      case 'de-DE': {
        registerLocaleData(localeGerman);
        break;
      }
    }
  }
}
